import React from 'react';
import PropTypes from "prop-types";
import AnchorLink from "react-anchor-link-smooth-scroll/lib/anchor-link";

function LocationToolTip ({ uid, name, closeModal }) {

    const locationToolTipStyling = {
        position: 'absolute',
        transformOrigin: 'bottom',
        transform: 'translate(-50%, 0)',
        backgroundColor: '#8E411D',
        color: '#fff',
        padding: '5px 10px',
        boxShadow: '0px 3px 20px #0000001A',
        borderRadius: '5px',
        fontSize: '15px',
        letterSpacing: '0.15px',
        zIndex: '100'
    };

    return (
        <span style={locationToolTipStyling} className='mapToolTip'>
            <AnchorLink offset='120' href={'#' + uid} onClick={closeModal}>{name}</AnchorLink>
        </span>

    );
}

LocationToolTip.propTypes = {
    uid: PropTypes.number,
    name: PropTypes.string,
    closeModal: PropTypes.func
};

export default LocationToolTip;




// WEBPACK FOOTER //
// ./src/components/Map/LocationToolTip.js